import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseModal } from '../Shared/Modal';
import RefundContent from '../RefundContent';

interface IRefundModalProps {
  isOpened: boolean;
  setIsOpened: Dispatch<SetStateAction<boolean>>;
}

export const RefundModal: FC<IRefundModalProps> = ({ isOpened, setIsOpened }) => {
  const { t } = useTranslation();
  return (
    <BaseModal isOpened={isOpened} onClickOutside={() => setIsOpened(false)}>
      <RefundContent closeHandler={() => setIsOpened(false)} />
    </BaseModal>
  );
};
